import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['name', 'email']

  select(event) {
    console.log(3)
    this.nameTarget.value = event.currentTarget.dataset.name
    this.emailTarget.value = event.currentTarget.dataset.email
  }

}
